import { useMemo } from 'react';
import type { AxiosInstance } from 'axios';
import { BaseAPI } from '../base';

export function useApi<T extends typeof BaseAPI>(
  axios: AxiosInstance,
  Api: T
): InstanceType<T> {
  const client = useMemo(
    () => new Api(undefined, axios.defaults.baseURL, axios) as InstanceType<T>,
    [axios, Api]
  );
  return client;
}
